// 电表接口
import request from "@utils/request"

const url = "api/Meter/"

/**
 *
 * 获取指定电表的概览数据（电表 - 数据概览）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMeterOverview (data) {
  return request({
    url: url + "GetMeterOverview",
    method: "post",
    data,
  })
}

/**
 *获取电站下的电量汇总概览
 * @param { * } data
 * @param { string } data.orgId - 电站ID
 * @returns { * }
 */
export function GetMeterEnergySummaryOverview (data) {
  return request({
    url: url + "GetMeterEnergySummaryOverview",
    method: "post",
    data,
  })
}

/**
 *
 * 获取电表的历史数据（电表 - 数据查询）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetHistoryData (data) {
  return request({
    url: url + "GetHistoryData",
    method: "post",
    data,
  })
}

/**
 *
 * 获取电表月/年对比分析数据（电表 - 对比分析）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetEnergyCompareData (data) {
  return request({
    url: url + "GetEnergyCompareData",
    method: "post",
    data,
  })
}

/**
 *
 * 分页查询电表的实时（电表 - 设备列表）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryMeterReals (data) {
  return request({
    url: url + "QueryMeterReals",
    method: "post",
    data,
  })
}

/**
 *
 * 查询电表的小时读数数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryMeterHourlyReading (data) {
  return request({
    url: url + "QueryMeterHourlyReading",
    method: "post",
    data,
  })
}

/**
 *
 * 抄表菜单
 * @export
 * @param {*} data
 * @return {*}
 */
export function MeterRead1 (data) {
  return request({
    url: url + "MeterRead1",
    method: "post",
    data,
  })
}

/**
 *
 * 抄表菜单
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpMeterRead1 (data) {
  return request({
    url: url + "ExpMeterRead1",
    method: "post",
    data,
  })
}
/**
 *
 * 电表报表
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMeterReportData (data) {
  return request({
    url: url + "GetMeterReportData",
    method: "post",
    data,
  })
}
/**
 *
 * 电表报表导出
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpMeterReport (data) {
  return request({
    url: url + "ExpMeterReport",
    method: "post",
    data,
  })
}

/**
 *
 * 获取电表电价
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetEPrices (data) {
  return request({
    url: url + "GetEPrices",
    method: "post",
    data,
  })
}

/**
 *
 * 设置电价
 * @export
 * @param {*} data
 * @return {*}
 */
export function SetEPrices (data) {
  return request({
    url: url + "SetEPrices",
    method: "post",
    data,
  })
}

/**
 *
 * 澳洲电表数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetAusMeterReportData (data) {
  return request({
    url: url + "GetAusMeterReportData",
    method: "post",
    data,
  })
}

/**
 *
 * 澳洲电表数据导出
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpAusMeterReport (data) {
  return request({
    url: url + "ExpAusMeterReport",
    method: "post",
    data,
  })
}

/**
 *
 * 澳洲电表电费单
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetBillData (data) {
  return request({
    url: url + "GetBillData",
    method: "post",
    data,
  })
}

/**
 *
 * 澳洲电表电费单导出
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpBill (data) {
  return request({
    url: url + "ExpBill",
    method: "post",
    data,
  })
}

/**
 *
 * 澳洲电表电费单信息设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function BillSetting (data) {
  return request({
    url: url + "BillSetting",
    method: "post",
    data,
  })
}

/**
 *
 * 设置澳洲电费单的台头
 * @export
 * @param {*} data
 * @return {*}
 */
export function SetBillHead (data) {
  return request({
    url: url + "SetBillHead",
    method: "post",
    data,
  })
}

/**
 *
 * 获取澳洲电费单的台头
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetBillHead (data) {
  return request({
    url: url + "GetBillHead",
    method: "post",
    data,
  })
}

/**
 *
 * 获取电费单设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetBillSetting (data) {
  return request({
    url: url + "GetBillSetting",
    method: "post",
    data,
  })
}

/**
 *
 * 删除电表
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteMeter (data) {
  return request({
    url: url + "DeleteMeter",
    method: "post",
    data,
  })
}

/**
 *
 * 分页查询分时查询
 * @export
 * @param {*} data
 * @return {*}
 */
export function PageQueryTimesShare (data) {
  return request({
    url: url + "PageQueryTimesShare",
    method: "post",
    data,
  })
}

/**
 * 获取分时费率列表
 * @returns
 */
export function QueryTimesShareList () {
  return request({
    url: url + "QueryTimesShareList",
    method: "post",
  })
}

/**
 *
 * 新增分时设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function AddTimesShare (data) {
  return request({
    url: url + "AddTimesShare",
    method: "post",
    data,
  })
}

/**
 *
 * 删除设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteTimesShare (data) {
  return request({
    url: url + "DeleteTimesShare",
    method: "post",
    data,
  })
}

/**
 *
 * 获取分配设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetTimesShare (data) {
  return request({
    url: url + "GetTimesShare",
    method: "post",
    data,
  })
}

/**
 *
 * 更新分配设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateTimesShare (data) {
  return request({
    url: url + "UpdateTimesShare",
    method: "post",
    data,
  })
}

/**
 *
 * 应用分配设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function ApplyTimesShare (data) {
  return request({
    url: url + "ApplyTimesShare",
    method: "post",
    data,
  })
}

/**
 *
 * 导出整点数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExportMeterHourlyReading (data) {
  return request({
    url: url + "ExportMeterHourlyReading",
    method: "post",
    data,
  })
}

/**
 *
 * 获取日月年电量数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function DMYEnergys (data) {
  return request({
    url: url + "DMYEnergys",
    method: "post",
    data,
  })
}

/**
 *
 * 导出日月年电量
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExportDMYEnergys (data) {
  return request({
    url: url + "ExportDMYEnergys",
    method: "post",
    data,
  })
}

/**
 *
 * 获取小时报表
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetAusHourMeterReportData (data) {
  return request({
    url: url + "GetAusHourMeterReportData",
    method: "post",
    data,
  })
}

/**
 *
 * 获取小时报表
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpAusHourMeterReport (data) {
  return request({
    url: url + "ExpAusHourMeterReport",
    method: "post",
    data,
  })
}

/**
 * 设置默认电表统计费率
 * @param { { timeShareId } } data
 * @returns
 */
export function SetDefaultTimeShare (data) {
  return request({
    url: `${url}SetDefaultTimeShare`,
    method: "post",
    data,
  })
}

/**
 * 获取电表历史有功功率总和无功功率总读数
 */
export function GetMeterPowerChartOfOverview (data) {
  return request({
    url: `${url}GetMeterPowerChartOfOverview`,
    method: "post",
    data,
  })
}

/**
 * 导出电表历史有功功率总和无功功率总读数
 * @returns
 */
export function ExportMeterPowerChartOfOverview (data) {
  return request({
    url: `${url}ExportMeterPowerChartOfOverview`,
    method: "post",
    data,
  })
}

/**
 * 更换采集器
 * @param {*} data
 * @returns
 */
export function ChangeGatewayByMeter (data) {
  return request({
    url: `${url}ChangeGatewayByMeter`,
    method: "post",
    data,
  })
}
